import { render } from "./BestiaryAbilityCompendiumModal.vue?vue&type=template&id=4e88fcf1"
import script from "./BestiaryAbilityCompendiumModal.vue?vue&type=script&lang=js"
export * from "./BestiaryAbilityCompendiumModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__